<div *ngIf="componentReady" [formGroup]="inputForm" class="ManagedDeletedAccountDialog d-flex flex-column gap-3">
    <h4>{{ headerText }}</h4>

    <mat-checkbox formControlName="deleted_forward" class="DeleteDataCheckbox">
        Enable "Forward to" functionality
    </mat-checkbox>

    <div class="d-flex flex-column" *ngIf="showNotificationPreferences">
        <p *ngIf="account.notification_email">Notification email: <span [appCopyText]="true">{{ account.notification_email }}</span></p>

        <mat-checkbox formControlName="change_notification_preferences" class="DeleteDataCheckbox">
            Manage notification email
        </mat-checkbox>

        <div class="d-flex flex-row align-items-center pt-3" *ngIf="inputForm.get('change_notification_preferences').value">
            <app-text-field formControlName="email" placeholder="Notification email"></app-text-field>
            <app-button class="ms-3" [text]="changeNotificationButtonProperties.text" [color]="changeNotificationButtonProperties.color" [size]="changeNotificationButtonProperties.size" [Click]="changeNotificationButtonProperties.onClick"></app-button>
        </div>
    </div>

    <p *ngIf="account.forward_to">Forwarding inbound emails until: <span>{{account.forward_to | timezone: 'MM/DD/YYYY'}}</span></p>
    <div class="d-flex flex-row gap-1">
       <div class=flex-grow-1>
        <app-select [items]="periods" formControlName="period" [label]="'Forwarding period'"></app-select>
       </div> 
       <div class=flex-grow-0>
        <div class="alert alert-warning">
            <p>Forward to” functionality allows soft-deleted accounts to receive inbound messages from their contacts for a given period.
If contact replies, when inbound message reaches Retreva’s servers it will not be declined due to the deleted status of the account.
Message will be forwarded to the soft-deleted account with enabled “forward to” setting.
If the account has a notification email set, it will be used as forwarding destination.
If no explicit notification email is set, the default account’s email address will be the forwarding destination for that message.
Forward period is calculated as date of the action + selected years. You can select either 1 or 2 years.
Soft deleted accounts with active forwarding functionality can be found in the Trash menu.
Admins can change the forwarding setting of soft deleted accounts</p>
        </div>
       </div>
    </div>
</div>